import axios, { getStandardAxiosConfig } from '../util/api';

class CowAPI {
  static fetch () {
    return axios.get('/cattle', getStandardAxiosConfig());
  }
  static fetchById (id) {
    return axios.get(`/cattle/${id}`, getStandardAxiosConfig());
  }
}

export default CowAPI;
